import { useState, useEffect, useRef } from 'react';
import { useApp } from '../context/AppContext';
import { translateTexts } from '../api';

// Auto-translates an array of texts into the active language (backend LLM, cached).
// Returns the translated array; falls back to the originals on error or English.
export const useTranslated = (texts) => {
  const { lang } = useApp();
  const [out, setOut] = useState(texts);
  const cache = useRef({});
  const key = JSON.stringify(texts);

  useEffect(() => {
    let mounted = true;
    if (!texts || texts.length === 0) { setOut(texts); return; }
    if (lang === 'en') { setOut(texts); return; }
    const ck = `${lang}|${key}`;
    if (cache.current[ck]) { setOut(cache.current[ck]); return; }
    setOut(texts); // show original while translating
    translateTexts(texts, lang)
      .then((res) => { if (mounted && Array.isArray(res)) { cache.current[ck] = res; setOut(res); } })
      .catch(() => {});
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, key]);

  return out;
};
